import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { StyledText } from './Text.styles';
const Text = ({ size = 'main', children, ...restProps }) => (_jsx(StyledText, { size: size, ...restProps, children: children }));
Text.displayName = 'Text';
export default Text;
